import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ChangeUserPasswordMutation } from '@numbox/apollo';

import { Banner } from '@library/Banner';
import { TextField } from '@library/TextField';
import { Button } from '@library/buttons/Button';

import { Prompt } from '../../shared/Prompt';
import { PromptContent } from '../../shared/PromptContent';
import { PromptHeader } from '../../shared/PromptHeader';

export const SetNewPassword = () => {
  const history = useHistory();
  const [newPassword, setNewPassword] = useState('');

  const isValid = newPassword.length >= 8;

  return (
    <ChangeUserPasswordMutation onCompleted={() => history.push('/inbox')}>
      {({ changePassword, error, loading }) => (
        <Prompt data-cy="set-new-password">
          <PromptHeader
            title="Set a new password"
            subtitle="Must be at least eight characters; at least one letter; at least one number"
          />

          <Banner visible={Boolean(error)} color="error">
            {error?.message}
          </Banner>
          <PromptContent>
            <TextField
              data-cy="login-password"
              id="login-password"
              name="password"
              type="password"
              placeholder="Password"
              label="Password"
              autoComplete="current-password"
              autoFocus
              value={newPassword}
              onChange={({ target: { value } }) => setNewPassword(value)}
              onKeyDown={event => {
                if (event.keyCode === 13) {
                  event.preventDefault();
                  event.stopPropagation();
                  if (isValid) {
                    changePassword({ newPassword });
                  }
                }
              }}
            />

            <Button
              isPrimary
              data-cy="set-password-btn"
              disabled={!isValid}
              onClick={() => changePassword({ newPassword })}
              inProgress={loading}
            >
              Set password
            </Button>
          </PromptContent>
        </Prompt>
      )}
    </ChangeUserPasswordMutation>
  );
};
